export default class AuthZeroConnectionViewModel{
    constructor(data) {
        this.name = data.name;
        this.displayName = data.displayName;
        this.id = data.id;
    }
}